import {
    ClickAwayListener,
    Tooltip,
    TooltipProps,
    useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import { theme } from '../../shared/theme';

export default function CustomTooltip(props: TooltipProps) {
    const { title, placement = 'bottom', children, ...rest } = props;

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useState(false);

    if (isMobile) {
        const handleToggle = (event: React.MouseEvent) => {
            event.stopPropagation();
            setOpen(!open);
        };

        return (
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Tooltip
                    {...rest}
                    title={title}
                    placement='bottom'
                    open={open}
                    onClose={() => setOpen(false)}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    onClick={handleToggle}
                >
                    {children}
                </Tooltip>
            </ClickAwayListener>
        );
    }

    return (
        <Tooltip {...rest} title={title} placement={placement}>
            {children}
        </Tooltip>
    );
}
